import React, { Component } from 'react';

const DocumentSidebar = ({children}) => (
    <aside className="admin-document__sidebar">{ children }</aside>
)

export default DocumentSidebar;